export type PetSpecies = "cat" | "fox" | "bot" | "owl" | "bunny" | "bear";

export interface PetPalette {
  background: string;
  primary: string;
  secondary: string;
  accent: string;
  ink: string;
}

export interface Pet {
  id: string;
  name: string;
  creator: string;
  creatorHandle: string;
  description: string;
  species: PetSpecies;
  tags: string[];
  collection: string;
  createdAt: string;
  views: number;
  likes: number;
  downloads: number;
  palette: PetPalette;
}

export const pets: Pet[] = [
  {
    id: "miso-byte",
    name: "Miso Byte",
    creator: "Nora Chen",
    creatorHandle: "noracodes",
    description: "A tiny debugging cat who naps beside the terminal and wakes up when tests turn red.",
    species: "cat",
    tags: ["pixel", "cozy", "debugger"],
    collection: "Terminal Companions",
    createdAt: "2026-07-19",
    views: 1842,
    likes: 326,
    downloads: 744,
    palette: { background: "#F3E8FF", primary: "#8B5CF6", secondary: "#C4B5FD", accent: "#FDE68A", ink: "#211A2E" },
  },
  {
    id: "ember-loop",
    name: "Ember Loop",
    creator: "Theo Park",
    creatorHandle: "theopark",
    description: "A warm fox familiar that circles long-running tasks and keeps the build queue moving.",
    species: "fox",
    tags: ["warm", "runner", "animated"],
    collection: "Build Crew",
    createdAt: "2026-07-18",
    views: 1293,
    likes: 241,
    downloads: 518,
    palette: { background: "#FFF1E7", primary: "#F97316", secondary: "#FDBA74", accent: "#22C55E", ink: "#2B1710" },
  },
  {
    id: "syntax-owl",
    name: "Syntax Owl",
    creator: "Ari Moss",
    creatorHandle: "arimoss",
    description: "A night-shift reviewer with sharp eyes for mismatched brackets and suspicious diffs.",
    species: "owl",
    tags: ["reviewer", "night", "wise"],
    collection: "Night Shift",
    createdAt: "2026-07-15",
    views: 1510,
    likes: 292,
    downloads: 602,
    palette: { background: "#EDE9FE", primary: "#312E81", secondary: "#818CF8", accent: "#FBBF24", ink: "#17152A" },
  },
  {
    id: "cloud-bun",
    name: "Cloud Bun",
    creator: "Iris Wang",
    creatorHandle: "irisloops",
    description: "A soft deployment bunny who floats between regions and celebrates healthy checks.",
    species: "bunny",
    tags: ["cloud", "cute", "deploy"],
    collection: "Cloud Garden",
    createdAt: "2026-07-14",
    views: 2088,
    likes: 447,
    downloads: 990,
    palette: { background: "#EFF6FF", primary: "#F8FAFC", secondary: "#BFDBFE", accent: "#EC4899", ink: "#1E293B" },
  },
  {
    id: "luna-cache",
    name: "Luna Cache",
    creator: "Sam Rivera",
    creatorHandle: "samrivera",
    description: "A moonlit cat that remembers the useful bits and quietly evicts stale context.",
    species: "cat",
    tags: ["memory", "moon", "quiet"],
    collection: "Night Shift",
    createdAt: "2026-07-12",
    views: 1733,
    likes: 381,
    downloads: 812,
    palette: { background: "#F5F3FF", primary: "#6D28D9", secondary: "#DDD6FE", accent: "#67E8F9", ink: "#1F1535" },
  },
  {
    id: "orbit-mini",
    name: "Orbit Mini",
    creator: "Pia Grant",
    creatorHandle: "piagrant",
    description: "A pocket robot that maps dependencies before anyone touches the release button.",
    species: "bot",
    tags: ["robot", "space", "planner"],
    collection: "Cloud Garden",
    createdAt: "2026-07-09",
    views: 1437,
    likes: 267,
    downloads: 588,
    palette: { background: "#ECFEFF", primary: "#0891B2", secondary: "#67E8F9", accent: "#A78BFA", ink: "#10272C" },
  },
  {
    id: "berry-stack",
    name: "Berry Stack",
    creator: "Lena Ortiz",
    creatorHandle: "lenaortiz",
    description: "A cheerful bunny who keeps frontend layers tidy and component props predictable.",
    species: "bunny",
    tags: ["frontend", "bright", "stack"],
    collection: "Cloud Garden",
    createdAt: "2026-07-06",
    views: 1218,
    likes: 255,
    downloads: 536,
    palette: { background: "#FFF1F2", primary: "#F43F5E", secondary: "#FDA4AF", accent: "#8B5CF6", ink: "#30141B" },
  },
];

export const allTags = [...new Set(pets.flatMap((pet) => pet.tags))].sort();
export const allCollections = [...new Set(pets.map((pet) => pet.collection))].sort();
